import { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import useSessionStorage from "./useSessionStorage";
import useEnv from "./useEnv";
import { JobContext } from "../contexts/JobContext";

const useLiveChat = () => {
    const { isEnvTruthy } = useEnv();
    const { userGetToken } = useSessionStorage();
    const location = useLocation();
    const [parameters, setParameters] = useState(null);
    const { job } = useContext(JobContext);

    /**
     * Set parameters for live chat widget if the feature is enabled and user is authenticated.
     * Parameters include user token and job id if on a job page.
     */
    useEffect(() => {
        if (!isEnvTruthy('SHOW_CHAT')) {
            return;
        }
        const token = userGetToken();
        if (token === null || token === '') {
            setParameters(null);
            return;
        }
        const path = location.pathname;
        const isJobPage = !path.includes('/jobsearch') && path.includes('/job');
        const params = [
            { name: 'token', value: token }
        ]
        if (isJobPage) {
            if (job !== null) {
                params.push({ name: 'jobid', value: job.jobid });
            }
        }
        setParameters(params);
    }, [location.pathname, job]);

    return {
        liveChatParameters: parameters
    }
}

export default useLiveChat;
